<div [ngClass]="'remote-img-container ' + (!!ghostClass ? ghostClass: '') + ' ' + (ghostMode ? 'ghost': '')" >
    <img *ngIf="remoteImgUrl && remoteImgUrl !== baseUrl"
         [src]="remoteImgUrl"
         [alt]="alt || ''"
         (load)="onLoad($event)"
         (error)="onError($event)"
         [className]="'ghost-hidden remote-img-content-' + displayMode"/>

    <div class="ghost-remote-img">
        <div class="ghost-hidden remote-img"></div>
    </div>
</div>

